import AttachmentItem from './AttachmentItem';
import AttachmentsForm from './AttachmentsForm'
import TableSectionDataDisplayOnly from '@rd-web-markets/de/dist/util/TableSectionDataDisplayOnly';
import React from 'react'
import { useTranslation } from 'react-i18next';
const FinancialAndPersonnelDocuments = ({ financialAndPersonnelDocuments, handleDelete, loading, handleSubmit, handleAttachmentChange, handleAttachmentSubmit, applicationSubmitted }) => {
  const { t } = useTranslation();
  
  return (
    <TableSectionDataDisplayOnly
      header={
        <AttachmentsForm
          handleSubmit={handleSubmit}
          loading={loading}
          applicationSubmitted={applicationSubmitted}
        />
      }
      head={
        <tr className='text-center'>
          <th>{t('date')}</th>
          <th>{t('document_name')}</th>
          <th>{t('notes')}</th>
          <th></th>
        </tr>
      }
      isEmpty={financialAndPersonnelDocuments.length === 0}
    >
      {financialAndPersonnelDocuments.map((att, index) => {
        return (
          <AttachmentItem
            key={att.id}
            applicationSubmitted={applicationSubmitted}
            attachment={att}
            index={index}
            handleAttachmentChange={handleAttachmentChange}
            handleDelete={handleDelete}
            handleAttachmentSubmit={handleAttachmentSubmit}
          />
        );
      })}
    </TableSectionDataDisplayOnly>
  )
}

export default FinancialAndPersonnelDocuments
